module.exports = require("./pt-AO.js");